import {  createSlice } from "@reduxjs/toolkit";
import { questionnaireIntialState } from "./intialState";

// localityList can be [],
// setExpiryDate 1 when expirydate is selected. otherwise 0. Expiryadate should not be selected
const initialState: any =questionnaireIntialState;

const questionnaireFormSlice = createSlice({
  name: "questionnaireForm",
  initialState,
  reducers: {
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
    
      // Split the field string into an array of nested properties
      const fieldArray = field.split(".");
    
      // Reference to the current state object
      let currentState = state;
    
      // Traverse the nested properties and update the value
      for (let i = 0; i < fieldArray.length - 1; i++) {
        // Check if the current property exists, if not, initialize it as an object
        if (!currentState[fieldArray[i]]) {
          currentState[fieldArray[i]] = {};
        }
    
        // Move to the next nested property
        currentState = currentState[fieldArray[i]];
      }
    
      // Update the last nested property with the new value
      currentState[fieldArray[fieldArray.length - 1]] = value;
    },
    submitForm: (state) => {
      // Logic to handle form submission (e.g., API call)
      // Reset form fields after successful submission if needed
      return initialState;
    },
    resetForm: () => initialState,
    updateFormData: (state, action) => {
      // Merge incoming form data with the current state
      return {
        ...state,
        ...action.payload, // Overwrite existing fields with new values
      };
    },
  },
});

export const { updateFormField, submitForm, resetForm, updateFormData } =
questionnaireFormSlice.actions;
export default questionnaireFormSlice;
